import { Request } from "../services/Requests";
const RequestBuilder = new Request.Builder("explore", "content");
import { Footer } from "../datatypes/Footer";

const service = {
    getContent(country: string, locale: string) {
        const template = "/content/snippets/{country}/{locale}";
        return RequestBuilder.path(template, { country: country, locale: locale }).get();
    },

    getCookieLawDisclaimer(country: string, locale: string) {
        const template = "/sitecore/cookielaw/{country}/{locale}";
        return RequestBuilder.path(template, { country: country, locale: locale }).get();
    },

    getSitecoreStoreInformation(country: string, locale: string) {
        const template = "/sitecore/storeinformation/{country}/{locale}";
        return RequestBuilder.path(template, { country: country, locale: locale }).get();
    },

    getSitecoreFooter(country: string, locale: string): Promise<Footer> {
        const template = "/sitecore/footer/{country}/{locale}";
        return RequestBuilder.path(template, { country, locale }).get();
    },

    getSearchContent(
        country: string,
        locale: string | null | undefined,
        query: string | null | undefined,
        rows: number | null | undefined,
        page: number | null | undefined
    ) {
        const template = "/sitecore/country/{country}/search";
        const queryParams = { query, rows, page, locale };
        return RequestBuilder.path(template, { country })
            .query(queryParams)
            .get();
    }
};

export default service;
